import { useMutation, useQueryClient } from '@tanstack/react-query';

import { timeoutDelay } from '@constants/timeoutDelay';

import { apiClient } from '@services/apiClient';
import { assetTreeKey } from '@services/useAssetTreeQuery';

import { locationsLogListKey } from './useLocationsLogListInfiniteQuery';

const locationsDeleteAssetFn = (data) => apiClient.post(`${APP_API_URL}locations/delete-asset`, data);

export const useLocationsDeleteAssetMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: locationsDeleteAssetFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: assetTreeKey() });
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: [locationsLogListKey()[0]] });
      }, timeoutDelay);
    },
  });
};
